import type { UserBirthday } from './types';

const LOCALSTORAGE_TOKEN_KEY = 'token';

function getInitialToken() {
  return localStorage.getItem(LOCALSTORAGE_TOKEN_KEY);
}

const usersBirthdays: UserBirthday[] = [
  {
    userId: 2664,
    name: 'Sophie',
    month: 10,
    day: 13
  },
  {
    userId: 2362,
    name: 'Brice',
    month: 10,
    day: 21
  },
  {
    userId: 4100,
    name: 'Karl',
    month: 3,
    day: 5
  },
  {
    userId: 7826,
    name: 'Clay',
    month: 3,
    day: 24
  },
  {
    userId: 9987,
    name: 'Dylan',
    month: 1,
    day: 11
  },
  {
    userId: 10181,
    name: 'Tsvetan',
    month: 6,
    day: 8
  }
];

function getBirthdayName(userId: number): string | undefined {
  const today = new Date();
  const month = today.getMonth() + 1;
  const day = today.getDate();

  const user = usersBirthdays.find(
    user => userId === user.userId && month === user.month && day === user.day
  );

  if (user) {
    return user.name;
  }
  return undefined;
}

const getdisplayedOverroundFromPreferences = (
  userPreferences: UserPreferences | undefined
): number | null => {
  if (userPreferences?.overround_display) {
    return userPreferences.overround_value ?? null;
  }
  return null;
};

export {
  LOCALSTORAGE_TOKEN_KEY,
  getInitialToken,
  getBirthdayName,
  getdisplayedOverroundFromPreferences
};
